import { Stack, Checkbox, FormControlLabel, FormHelperText, Typography, Link } from '@mui/material';

export type ConsentCheckboxProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  error?: string;
  t: (key: string) => string;
};

export function ConsentCheckbox({
  checked,
  onChange,
  disabled = false,
  error,
  t,
}: ConsentCheckboxProps) {
  return (
    <Stack>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={(e) => onChange(e.target.checked)}
            disabled={disabled}
            size="small"
            sx={{
              padding: '8px',
              '&.Mui-disabled': {
                color: 'grey.400',
              },
              ...(error && {
                color: 'error.main',
              }),
            }}
          />
        }
        label={
          <Typography
            variant="body2"
            sx={{
              fontSize: '0.875rem',
              lineHeight: 1.4,
              color: 'text.primary',
            }}
          >
            {t('labels.leadFormConsentStart')}
            &nbsp;
            <Link
              href="https://www.2.yad2.co.il/privacy"
              target="_blank"
              rel="noopener noreferrer"
              color="primary"
            >
              {t('labels.leadFormConsentPrivacy')}
            </Link>
            &nbsp;
            <Link
              href="https://www.2.yad2.co.il/eula"
              target="_blank"
              rel="noopener noreferrer"
              color="primary"
            >
              {t('labels.leadFormConsentEula')}
            </Link>
            &nbsp;
            {t('labels.leadFormConsentEnd')}
          </Typography>
        }
        sx={{
          alignItems: 'flex-start',
          marginLeft: 0,
          marginRight: 0,
          '& .MuiFormControlLabel-label': {
            paddingLeft: '8px',
          },
        }}
      />
      {error && (
        <FormHelperText
          error
          sx={{
            fontSize: '0.8rem',
            marginLeft: '3px',
            marginRight: '3px',
            marginTop: '4px',
          }}
        >
          {error}
        </FormHelperText>
      )}
    </Stack>
  );
}
